module.exports = __webpack_public_path__ + "944e24c04449fbbff898e270e1216ce9.jpg"


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/images/shop/stones-throw.jpg
 ** module id = 480
 ** module chunks = 0
 **/